export default __webpack_public_path__ + "static/media/mop-dimension.7b796be8.svg";